import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { useAppContext } from 'new-components/OpAppScaffold/components/AppContext';
import { getAppOrigin } from 'utils/getAppOrigin';

export const useNavigateToMailroom = (orgId: number) => {
  const { app } = useAppContext();

  const navigate = useNavigate();

  const handleNavigateToMailroom = useCallback(() => {
    if (app === 'mailroom') {
      navigate(0);
      return;
    }

    window.open(`${getAppOrigin('mailroom')}/o/${orgId}`, '_self');
  }, [app, navigate, orgId]);

  return {
    handleNavigateToMailroom,
  };
};
